module.exports = __webpack_public_path__ + "static/media/waterfall.40119d12.mp4";